export default __webpack_public_path__ + "static/media/Wesley.6d41e879.jpg";